const listeners = new Set()

let currentPageAssistantState = null

export const ORBIT_OPEN_INDIE_PANEL_EVENT = 'orbit:open-indie-panel'

export function getOrbitPageAssistantState() {
  return currentPageAssistantState
}

export function publishOrbitPageAssistantState(nextState) {
  currentPageAssistantState = nextState || null
  listeners.forEach((listener) => listener(currentPageAssistantState))
}

export function clearOrbitPageAssistantState(source) {
  if (!source || currentPageAssistantState?.source === source) {
    publishOrbitPageAssistantState(null)
  }
}

export function subscribeOrbitPageAssistantState(listener) {
  if (typeof listener !== 'function') {
    return () => {}
  }

  listeners.add(listener)
  listener(currentPageAssistantState)

  return () => {
    listeners.delete(listener)
  }
}

export function requestOrbitIndiePanelOpen(detail = {}) {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') {
    return
  }

  window.dispatchEvent(new CustomEvent(ORBIT_OPEN_INDIE_PANEL_EVENT, {
    detail,
  }))
}
